import Clipboard from 'clipboard';

export class Controller {

    /** @ngInject */
    constructor($scope, Alert) {
        this.$scope = $scope;
        this.Alert = Alert;
    }

    $onInit() {
        new Clipboard(".copyCli").on('success', () => {
            this.$scope.$apply(() => {
            this.Alert('success', 'global.data_copied')
            })
        })
    }

    openUrl(url) {
        window.location.href = url;
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/app-integration-instructions/saml-metadata/saml-metadata.controller.js